<template>
  <div class="d-flex justify-center md-10">
    <v-card width="100%" style="margin-top:20px" class="rounded-lg">
      <v-parallax
        light
        src="../assets/horses-1280_852.jpg"
      >
        <v-row
          align="center"
          justify="center"
        >
          <v-col class="text-center" cols="12" style="background-color: rgba(20, 26, 200, 0.5)">
            <h1 class="display-1 font-weight-thin mb-4">Hjälp På Traven</h1>
            <h4 class="subheading">Kraftfullt verktyg för reducering av travsystem</h4>
          </v-col>
        </v-row>
      </v-parallax>
    </v-card>
  </div>
</template>
<style>
.package-card {
  margin:20px
}
</style>
<script>
// @ is an alias to /src
export default {
  name: 'home',
  components: {
  },

  data () {
    return {
    }
  }
}
</script>
